// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_is-6";
export var emphasizeQuantity = "_is-3";
export var flatBottomCorners = "_is-5";
export var productImage = "_is-0";
export var quantityContainer = "_is-2";
export var tooltip = "_is-1";
export var wrapAndEllipsesOverflow = "_is-4";